import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const CustomerDetailIntro = (props) => {
  const { t } = useTranslation();
  const { content, imgUrl, alt } = props;
  return (
    <section>
      <div className="customer-detail-intro">
        <div className="inner">
          <div className="content">
            <Title
              title={t("customer.heigh-educate.intro.title")}
              align="left"
            />
            <div className="customer-detail-intro-warp">
              <div className="heigh-educate-intro-text">{content}</div>
              <div className="heigh-educate-img">
                <img src={imgUrl} alt={alt} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
